import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Row, Col, Button, Input, Switch, Select, List, Spin } from 'antd';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { EditAppProject, DeleteApp } from '../gqls'
import Client from '../../../../lib/gqlClient';
import JoinedMembersItemPage from './joinedMembersItem';
const PermissionManagementPage = (props, ref) => {
    const { TextArea } = Input;
    const navigate = useNavigate();

    const [isGetData, setIsGetData] = useState(false)
    const [projectInfoView, setProjectInfoView] = useState('none');
    const [owner, setOwner] = useState()
    const [id, setId] = useState()
    const [isOpenPassword, setIsOpenPassword] = useState(false)
    const [password, setPassword] = useState()
    const [isOpenLimit, setIsOpenLimit] = useState(false)
    const [limit, setLimit] = useState(0)
    const [membersList, setMembersList] = useState([]);
    const [members, setMembers] = useState();
    const [joinedMembersList, setJoinedMembersList] = useState([]);

    React.useEffect(() => {


    }, [])
    useImperativeHandle(ref, () => {
        return {
            setData,
            setProjectInfoViewShow,
            setMembersLists
        }
    });
    function setData(data) {
        //可编辑成员
        setId(data._id)
        const members = data.members
        setJoinedMembersList(members)
        setMembers(members)
        setIsOpenPassword(data.hasPassword)
        if (data.hasPassword) {
            setPassword(data.password)
        }
        if (data.limit === null || data.limit.downloadMax === 0) {
            setIsOpenLimit(false)
        } else {
            setIsOpenLimit(true)
            setLimit(data.limit.downloadMax)
        }
        setOwner(data.owner)
    }
    function setProjectInfoViewShow(data) {
        setProjectInfoView(data)
    }
    function setMembersLists(data) {
        setMembersList(data)
    }
    const onChangeOpenPasswordSwitch = (checked) => {
        if (!checked) {
            setPassword('')
        }
        setIsOpenPassword(checked)

    }
    const onChangeOpenLimitSwitch = (checked) => {
        if (!checked) {
            setLimit(0)
        } else {
            setLimit(1000)
        }
        setIsOpenLimit(checked)
    }

    const showInpPassword = e => {
        if (e.target.value === '') {
            setIsOpenPassword(false)
        } else {
            setIsOpenPassword(true)
        }
        setPassword(e.target.value);
    }
    const showInpLimit = e => {
        if (e.target.value === '' || e.target.value === '0') {
            setIsOpenLimit(false)
        } else {
            setIsOpenLimit(true)
        }
        if (parseInt(e.target.value) >= 1000) {
            setLimit(1000);
        } else { 
            setLimit(parseInt(e.target.value)); 
        }

    }

    const onItemsMembersClick = (value) => {
        if (!members.includes(value)) {
            var list = []
            list = list.concat(members)
            list[members.length] = value
            setMembers(list)
        }

    };
    function onDeselectMembers(value) {
        console.log(value)
        var list = [{}]
        members.map((item, index) => {
            list[index] = item
        })
        list.splice(list.indexOf(value), 1)
        setMembers(list)
        console.log(list)
    }
    function onClearMembers() {
        setMembers([])
    }
    function editProject() {
        editAppProject(limit, password, members)
    }
    function editAppProject(limit, password, members) {
        setIsGetData(true)
        Client(
            null,
            {
                editAppProjectId: id,
                limit: limit,
                password: password,
                members: members
            },
            EditAppProject
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                setMembers(res.data.editAppProject.members)
                setJoinedMembersList(res.data.editAppProject.members)
            }
            setIsGetData(false)
        }).catch(e => {
            // console.log(e);
            setMembers(joinedMembersList)
            setIsGetData(false)
        })
    }
    return (
        <Spin size="large" tip="Loading..." spinning={isGetData} >
            <div
                style={{ marginLeft: '30px', marginTop: '30px', display: projectInfoView }}>
                <Row style={{ display: 'flex', alignItems: 'center', }}>
                    <div style={{ fontSize: '18px', width: '160px' }}>owner:</div>
                    <div style={{ fontSize: '18px', width: '160px' }}>{owner}</div>
                </Row>
                <Row style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ fontSize: '18px', width: '160px' }}>开启访问密码:</div>
                    <Switch style={{ marginRight: '10px', marginLeft: '5px', }}
                        checked={isOpenPassword} onChange={onChangeOpenPasswordSwitch} />
                    <TextArea
                        value={password}
                        maxLength={8}
                        rows={1}
                        onChange={showInpPassword}
                        style={{ width: '200px', height: '35px', resize: 'none', }} />
                    <Button onClick={() => editProject()} style={{ width: '120px', height: '35px', borderRadius: '4px', fontSize: '20px', background: '#FF5300', color: 'white', fontSize: '12px', marginLeft: '50px' }}>保存</Button>

                </Row>
                <Row style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ fontSize: '18px', width: '160px' }}>开启每天最高下载:</div>
                    <Switch style={{ marginRight: '10px', marginLeft: '5px', }}
                        checked={isOpenLimit} onChange={onChangeOpenLimitSwitch} />
                    <Input
                        value={limit}
                        maxLength={8}
                        rows={1}
                        type='number'
                        onChange={showInpLimit}
                        style={{ width: '200px', height: '35px', resize: 'none', }} />
                </Row>
                <Row style={{ marginTop: '10px' }}>
                    <Col style={{ width: '220px', display: 'flex', alignItems: 'center', fontSize: '18px', color: '#3D3D3D', }}>
                        可编辑人员:
                    </Col>
                    <Col>
                        <div style={{
                            width: '200px', height: '35px', backgroundColor: '#fff', borderRadius: "2px", border: '1px solid rgba(0, 0, 0, 0.2)'
                        }}>
                            <Select
                                className='select'
                                mode="multiple"
                                size='middle'
                                allowClear
                                style={{
                                    width: '100%',
                                }}
                                maxTagCount='responsive'
                                showArrow={true}
                                bordered={false}
                                placeholder="Please select"
                                onSelect={onItemsMembersClick}
                                options={membersList}
                                value={members}
                                onClear={onClearMembers}
                                onDeselect={onDeselectMembers}
                            />
                        </div>
                    </Col>
                </Row>
                <Row style={{ marginTop: '30px', display: 'flex', alignItems: 'center', }}>
                    <div style={{ fontSize: '20px' }}>
                        成员列表
                    </div>
                    {/* <Button style={{ marginLeft: '15px', width: '50px', height: '25px', fontSize: '15px', borderRadius: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>编辑</Button> */}
                </Row>

                <List
                    grid={{
                        gutter: 20,
                        column: 8,
                    }}
                    dataSource={joinedMembersList}
                    renderItem={(item, index) => (
                        <List.Item >
                            <JoinedMembersItemPage
                                item={item}
                                index={index} />
                        </List.Item>

                    )}
                    style={{ marginTop: '20px', width: '1184px' }}
                />
            </div>
        </Spin>
    )

}

export default forwardRef(PermissionManagementPage)